import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  Grid,
  CircularProgress,
  Button,
  Paper,
  IconButton,
  TextField,
  MenuItem,
} from "@mui/material";

import {
  projectActivitiesTable,
  projectEmployeesTable,
  projectReccuringActivitiesTable,
  projectTaskTable,
} from "../../config/grid-columns-defs";

import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {
  deleteProject,
  getLowestLevelTask,
  getProjectById,
  getProjectTasks,
  // updateProject,
} from "../../api/project";
import { handleAxiosError } from "../../config/action-config";
import {
  createTask,
  deleteTask,
  updateTask,
  updateTaskBudget,
} from "../../api/task";
import {
  assignEmployeeToProject,
  deleteEmployeeProject,
  updateEmployeeProject,
} from "../../api/employeeProject";

import { showAlert } from "../../actions/alert";

import {
  allActivityAttachment,
  createActivity,
  deleteActivity,
  getActivities,
  getRecurringActivities,
  updateActivity,
} from "../../api/activity";
import { Forum } from "@mui/icons-material";
import ConditionalRenderer from "../../component/ConditionalRenderer";
import AgGridPaginatedTable from "../../component/AgGridPaginatedTable";
import UpdateActivityDialog from "../projects/dialog.update-activity";
import DeleteDialog from "../projects/dialog.delete";
import ChatDrawer from "../projects/chat-drawer";
import { getProjects } from "../../api/project";
import AddRecurringActivityDialog from "../projects/dialog.add-recurring-activity";
import UpdateRecurringActivityDialog from "../projects/dialog.update-recurring-activity";
import ItemDialogUploadDoc from "../../component/DialogUploadExcel";

const deleteApis = {
  PROJECT: deleteProject,
  TASK: deleteTask,
  EMPLOYEE: deleteEmployeeProject,
  ACTIVITY: deleteActivity,
};

const emptyProjectData = {
  project_name: "",
  project_type: "",
  project_description: "",
  budget: "",
  id: "",
  pm_id: "",
  start_date: "",
  end_date: "",
  status: "",
  creation_date: "",
  customer_id: "",
  customer_name: "",
  customer_email: "",
};

export default function ProjectRecurringActivities({ projectSelectId }) {
  // useEffect(() => {
  //   const projectType = localStorage.getItem("projectType");

  // }, []);
  const user = useSelector((state) => state.user);
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [projectData, setProjectData] = useState(emptyProjectData);
  const [lowestTasks, setLowestTasks] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [recurringActivities, setRecurringActivities] = useState([]);
  const [employeeTaskName, setEmployeeTaskName] = useState("");
  const [employeeTabEmployeeName, setEmployeeTabEmployeeName] = useState("");
  const [recurringActivityTaskName, setRecurringActivityTaskName] =
    useState("");
  const [recurringActivityEmployeeName, setRecurringActivityEmployeeName] =
    useState("");
  const [selectedRecurringActivityRow, setSelectedRecurringActivityRow] =
    useState(0);
  const [recurringActivitiesRefreshCount, setRecurringActivitiesRefreshCount] =
    useState(0);
  function refreshRecurringactivitiesTable() {
    setRecurringActivitiesRefreshCount((prev) => prev + 1);
  }
  const [projectList, setProjectList] = useState([]);
  // const [projectId, setProjectId] = useState("");
  // const [projectName, setProjectName] = useState(projectSelectId);
  const [openDialog, setOpenDialog] = useState({
    DELETE: false,
    ADD_RECURRING_ACTIVITY: false,
    UPDATE_RECURRING_ACTIVITY: false,
    UPLOAD_EXCEL: false,
  });

  const [openChatDrawer, setOpenChatDrawer] = useState(false);

  if (
    !projectReccuringActivitiesTable.some((d) => d.headerName === "Comments")
  ) {
    projectReccuringActivitiesTable.unshift({
      headerName: "Comments",
      wrapText: true,
      autoHeight: true,
      cellStyle: () => ({
        fontSize: "11px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }),
      headerClass: "justify-center",
      cellClass: "pmt-ag-cell-font justify-center",
      miWidth: 100,
      cellRenderer: (params) => (
        <IconButton
          color="primary"
          // onClick={() => {
          //   setSelectedActivityRow(params.data.id);
          //   setOpenChatDrawer(true);
          // }}
        >
          <Forum />
        </IconButton>
      ),
    });
  }

  function toggleDialogOpen(dialog) {
    setOpenDialog((prev) => ({ ...prev, [dialog]: !openDialog[dialog] }));
    console.log("dialo==", dialog);
  }

  useEffect(() => {
    getProjectsData();
  }, [projectSelectId]);
  async function getProjectsData() {
    try {
      const { data } = await getProjects({}, user.token);

      setProjectList(data.data);
      return {
        rows: data.data,
        total: data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }
  async function loadLowestLevelTask() {
    let specific = false;
    if (user.role === "User") {
      specific = true;
    }
    try {
      const { data } = await getLowestLevelTask(
        projectSelectId,
        user.token,
        specific
      );
      setLowestTasks(data.data);
    } catch (error) {
      handleAxiosError(error);
    }
  }
  async function loadMasterData() {
    try {
      const { data } = await getProjectById(
        projectSelectId,
        {
          task_name: employeeTaskName,
          employee_name: employeeTabEmployeeName,
        },
        user.token
      );
      setProjectData(data.data.project);
      setEmployees(data.data.employees);
      return {
        rows: data.data.employees,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (projectSelectId) {
      loadLowestLevelTask();
      loadMasterData();
      loadProjectReccuringActivities(10, 0);
    }
    return;
  }, [projectSelectId]);
  async function loadProjectReccuringActivities(limit, offset) {
    try {
      const { data } = await getRecurringActivities(
        projectSelectId,
        {
          is_recurring: true,
          task_name: recurringActivityTaskName,
          employee_name: recurringActivityEmployeeName,
          limit,
          offset,
        },
        user.token
      );
      setRecurringActivities(data.data);
      return {
        rows: data.data,
        total: data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  const [deletingContent, setDeletingContent] = useState({ table: "", row: 0 });

  async function onDelete() {
    const deleteApi = deleteApis[deletingContent.table];
    try {
      const { data } = await deleteApi(deletingContent.row, user.token);
      dispatch(showAlert(data.msg));
      setDeletingContent({ type: "", row: 0 });
      setSelectedRecurringActivityRow(0);
      switch (deletingContent.table) {
        case "ACTIVITY":
          refreshRecurringactivitiesTable();
          break;
        default:
          break;
      }
    } catch (error) {
      setDeletingContent({ table: "", row: 0 });
      handleAxiosError(error);
    }
  }

  async function onRecurringActivityAdd(postData) {
    const combinedData = { ...postData, is_recurring: true };
    try {
      const { data } = await createActivity(
        { ...combinedData, project_id: projectData.id },
        user.token
      );
      refreshRecurringactivitiesTable();
      toggleDialogOpen("ADD_RECURRING_ACTIVITY");

      dispatch(showAlert(data.msg));
    } catch (error) {
      toggleDialogOpen("ADD_RECURRING_ACTIVITY");
      handleAxiosError(error);
    }
  }

  async function onRecurringActivityUpdate(patchData) {
    try {
      const { data } = await updateActivity(
        selectedRecurringActivityRow,
        patchData,
        user.token
      );
      refreshRecurringactivitiesTable();
      toggleDialogOpen("UPDATE_RECURRING_ACTIVITY");
      dispatch(showAlert(data.msg));
      setSelectedRecurringActivityRow(0);
    } catch (error) {
      toggleDialogOpen("UPDATE_RECURRING_ACTIVITY");
      handleAxiosError(error);
    }
  }
  const onItemDialogAttachmentSubmit = async (formData) => {
    try {
      const { data } = await allActivityAttachment(formData, user.token);

      // getTicketAttachmentTableData();
      dispatch(showAlert(data.msg));
      toggleDialogOpen("UPLOAD_EXCEL");
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };

  useEffect(() => {
    refreshRecurringactivitiesTable();
  }, [
    projectSelectId,
    recurringActivityEmployeeName,
    recurringActivityTaskName,
  ]);

  return (
    <>
      {/* <Paper sx={{ display: "flex", columnGap: 1, p: 2, borderBottom: 1 }}>
        <Grid item sm={6} md={6} lg={3} xl={3}>

          <TextField
            label="Projects"
            value={projectName}
            variant="outlined"
            select
            fullWidth
            onChange={(e) => {
              setProjectName(e.target.value);
            }}
          >
            <MenuItem value="">Select</MenuItem>
            {projectList?.map((c, i) => (
              <MenuItem key={i} value={c.id}>
                {c.project_name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Paper> */}
      {projectSelectId && (
        <Paper sx={{ width: "100%" }}>
          <Box
            sx={{
              display: { lg: "flex", md: "flex", sm: "block", xs: "grid" },
              alignItems: "center",
              justifyContent: "space-between",
              p: 2,
              borderBottom: 1,
            }}
          >
            <ConditionalRenderer
              conditions={[
                user.role === "Admin",
                user.role === "User",
                user.role === "Trial_User",
                projectData.pm_id === user.roleId,
              ]}
              match="SOME"
            >
              {/* <Button
            variant="contained"
            style={{ padding: "5px 7px" }}
            onClick={() => {
              toggleDialogOpen("UPLOAD_EXCEL");
            }}
            className="blue-button"
          >
            Upload
          </Button> */}
              <Button
                variant="contained"
                onClick={() => {
                  toggleDialogOpen("ADD_RECURRING_ACTIVITY");
                }}
                className="blue-button"
                sx={{
                  marginBottom: { xs: "5px", md: "0px" },
                  marginRight: { sm: "5px", md: "10px" },
                }}
              >
                Add Activity
              </Button>
              <ConditionalRenderer
                conditions={[
                  user.role === "Admin",
                  projectData.pm_id === user.roleId,
                ]}
                match="SOME"
              >
                <ConditionalRenderer
                  conditions={[Boolean(selectedRecurringActivityRow)]}
                >
                  <Button
                    className="blue-button"
                    variant="contained"
                    onClick={() => {
                      setDeletingContent({
                        table: "ACTIVITY",
                        row: selectedRecurringActivityRow,
                      });
                    }}
                    sx={{
                      marginBottom: { xs: "5px", md: "0px" },
                      marginRight: { sm: "5px", md: "10px" },
                    }}
                  >
                    Delete Selected
                  </Button>
                </ConditionalRenderer>
              </ConditionalRenderer>
            </ConditionalRenderer>
            <ConditionalRenderer
              conditions={[Boolean(selectedRecurringActivityRow)]}
            >
              <Button
                variant="contained"
                className="blue-button"
                onClick={() => {
                  toggleDialogOpen("UPDATE_RECURRING_ACTIVITY");
                }}
                sx={{
                  marginBottom: { xs: "5px", md: "0px" },
                  marginRight: { sm: "5px", md: "10px" },
                }}
              >
                Update Selected
              </Button>
            </ConditionalRenderer>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              xl={6}
              display={{ sm: "flex !important" }}
              sx={{
                float: { lg: "right" },
              }}
            >
              <TextField
                size="small"
                fullWidth
                sx={{
                  marginRight: { sm: "5px", md: "10px" },
                  marginBottom: { xs: "5px", md: "0px" },
                }}
                value={recurringActivityEmployeeName}
                label="Employee Name"
                onChange={(e) => {
                  setRecurringActivityEmployeeName(e.target.value);
                }}
                // rowsMax={1}
              />
              <TextField
                size="small"
                fullWidth
                sx={{
                  marginRight: { sm: "5px", md: "10px" },
                  marginBottom: { xs: "5px", md: "0px" },
                }}
                value={recurringActivityTaskName}
                label="Task Name"
                onChange={(e) => {
                  setRecurringActivityTaskName(e.target.value);
                }}
              />
              <Button
                variant="contained"
                style={{ padding: "5px 7px" }}
                sx={{
                  marginBottom: { xs: "5px", md: "0px" },
                }}
                fullWidth
                onClick={() => {
                  toggleDialogOpen("UPLOAD_EXCEL");
                }}
                className="blue-button"
              >
                Upload
              </Button>
            </Grid>
          </Box>

          <ChatDrawer
            open={openChatDrawer}
            setOpen={setOpenChatDrawer}
            activityId={selectedRecurringActivityRow}
          />

          <div className="pmt-controll-table">
            {projectSelectId ? (
              <AgGridPaginatedTable
                getTableRows={loadProjectReccuringActivities}
                columns={projectReccuringActivitiesTable}
                perPage={10}
                refreshCounter={recurringActivitiesRefreshCount}
                rowSelection="single"
                onRowClicked={(params) => {
                  let allowedToSelect =
                    /admin/i.test(user.role) ||
                    projectData.pm_id === user.roleId ||
                    (/user|ReportingManager/i.test(user.role) &&
                      params.data.employee_id === user.roleId);
                  if (allowedToSelect) {
                    setSelectedRecurringActivityRow(params.data.id);
                  } else {
                    setSelectedRecurringActivityRow(0);
                  }
                }}
                onCellClicked={({ rowIndex, column, data }) => {
                  if (column.colId === "0") {
                    let allowedToComment =
                      /admin/i.test(user.role) ||
                      projectData.pm_id === user.roleId ||
                      (/user|ReportingManager/i.test(user.role) &&
                        data.employee_id === user.roleId);
                    if (allowedToComment) {
                      setSelectedRecurringActivityRow(data.id);
                      setOpenChatDrawer(true);
                    }
                  }
                }}
                // onRowClicked={(params) => {
                //   let allowedToSelect =
                //     /admin/i.test(user.role) ||
                //     projectData.pm_id === user.roleId ||
                //     (/user|ReportingManager/i.test(user.role) &&
                //       recurringActivities[params.rowIndex].employee_id ===
                //         user.roleId);
                //   if (allowedToSelect) {
                //     setSelectedRecurringActivityRow(params.data.id);
                //   }
                // }}
                // onCellFocused={({ rowIndex, column }) => {
                //   if (column.colId === "0") {
                //     let allowedToComment =
                //       /admin/i.test(user.role) ||
                //       projectData.pm_id === user.roleId ||
                //       (/user|ReportingManager/i.test(user.role) &&
                //         recurringActivities[rowIndex].employee_id ===
                //           user.roleId);
                //     if (allowedToComment) {
                //       setSelectedRecurringActivityRow(
                //         recurringActivities[rowIndex].id
                //       );
                //       setOpenChatDrawer(true);
                //     }
                //   }
                // }}
              />
            ) : (
              <></>
            )}
          </div>
          <ItemDialogUploadDoc
            activityType={"n"}
            open={openDialog.UPLOAD_EXCEL}
            setOpen={toggleDialogOpen}
            onSubmit={onItemDialogAttachmentSubmit}
          />
          <DeleteDialog
            deletingContent={deletingContent}
            setDeletingContent={setDeletingContent}
            onDelete={onDelete}
          />
          <AddRecurringActivityDialog
            open={openDialog.ADD_RECURRING_ACTIVITY}
            setOpen={toggleDialogOpen}
            lowestTasks={lowestTasks}
            employees={employees}
            onAdd={onRecurringActivityAdd}
          />

          <UpdateRecurringActivityDialog
            open={openDialog.UPDATE_RECURRING_ACTIVITY}
            setOpen={toggleDialogOpen}
            lowestTasks={lowestTasks}
            employees={employees}
            projectData={projectData}
            selectedActivity={recurringActivities.find(
              (a) => a.id === selectedRecurringActivityRow
            )}
            onUpdate={onRecurringActivityUpdate}
          />
        </Paper>
      )}
    </>
  );
}
